import { Box, IconButton } from "@mui/material";
import { SavedBrandContext } from "contexts/SavedBrand";
import { SavedBrandCollectionsContext } from "contexts/SavedBrandCollections";
import { useContext } from "react";
import { BentoBrand } from "schemas/dashboard";
import { CustomEvent } from "schemas/functions";
import { HEART_COLOR } from "styles/oneOffColor";

import { useCollection } from "utils/useCollection";

interface IProps {
  brand: BentoBrand;
}

const styles = {
  savedHeart: {
    color: HEART_COLOR,
    fontSize: 16,
  },
  iconWrapper: {
    fontSize: 16,
    display: "inline-block",
    lineHeight: 1,
    verticalAlign: "middle",
  },
};

export default function FavoriteIconButton({ brand }: IProps) {
  const { isSavedBrand } = useCollection();
  const { selectedCollection } = useContext(SavedBrandCollectionsContext);
  const { handleAddDebounced, handleRemoveDebounced } =
    useContext(SavedBrandContext);
  const isSelected = isSavedBrand(brand);

  return (
    <IconButton
      sx={isSelected ? styles.savedHeart : { fontSize: 16 }}
      onClick={(e: CustomEvent) => {
        e.stopPropagation();
        isSelected
          ? handleRemoveDebounced(brand, selectedCollection?.id || 0)
          : handleAddDebounced(e.currentTarget, brand);
      }}
    >
      <Box
        component="i"
        className={
          isSelected ? "fa-solid fa-bookmark" : "fa-regular fa-bookmark"
        }
        sx={styles.iconWrapper}
      />
    </IconButton>
  );
}
